
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"22","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.075 20.335L4.437 15.27 3.16 20.335h11.915z","stroke":"currentColor","stroke-opacity":".7","stroke-width":"1.5","fill":"none"}}),_c('path',{attrs:{"d":"M4.436 15.27l5.266 2.422 3.138-7.486 8.159-.505L5.624 9.7l-1.188 5.57zM23.122 20.323l-2.563-10.13L9.824 17.61l5.34 2.713h7.958z","stroke":"currentColor","stroke-opacity":".7","stroke-width":"1.5","fill":"none"}}),_c('path',{attrs:{"d":"M8.5 8.146a1.77 1.77 0 110-3.542 1.77 1.77 0 010 3.542zm0-6.73A4.958 4.958 0 003.54 6.376c0 3.719 4.958 9.208 4.958 9.208s4.959-5.49 4.959-9.208a4.958 4.958 0 00-4.959-4.958z","fill":"#fff"}}),_c('path',{attrs:{"d":"M8.5 7.708c-.358 0-.703-.153-.957-.427a1.517 1.517 0 01-.397-1.031c0-.387.143-.758.397-1.031.254-.274.599-.427.958-.427s.703.153.957.427c.254.273.397.644.397 1.031 0 .191-.035.381-.103.558a1.47 1.47 0 01-.294.473 1.352 1.352 0 01-.44.316 1.27 1.27 0 01-.517.111zm0-5.541c-1.005 0-1.97.43-2.68 1.196A4.248 4.248 0 004.709 6.25c0 3.062 3.792 7.583 3.792 7.583s3.791-4.52 3.791-7.583c0-1.083-.4-2.122-1.11-2.887-.711-.766-1.676-1.196-2.681-1.196z","fill-opacity":".7"}})])
          )
        }
      }
    